import React from 'react';

import name from './name';

import Asset from '../Asset';
import Box from '../Box/Box';
import Text from '../Text';
import { Title4 } from '../Title';
import { PrimaryButton, TertiaryButton } from '../Button';
import { TAsset } from '../../types/TStyleVariables';

type TCta = {
  text: string;
  onClick?: () => void;
  href?: string;
  as?: 'a' | 'button';
};

type TEmptyState = {
  illustration?: TAsset;
  title: string;
  description?: string;
  primaryCta?: TCta;
  secondaryCta?: TCta;
};

const EmptyState = ({
  illustration = 'empty-state-heart',
  title,
  description,
  primaryCta,
  secondaryCta,
}: TEmptyState) => (
  <Box as="div" name={name}>
    <Box as="div" name="Content" parent={name}>
      <Box as="div" name="Body" parent={name}>
        <Box as="div" name="Icon" parent={name}>
          <Asset.Square name={illustration} size="xxxl" />
        </Box>
        <Box as="div" name="Title" parent={name}>
          <Title4>{title}</Title4>
        </Box>
        {description && (
          <Box as="div" name="Description" parent={name}>
            <Text.BodyBase as="p">{description}</Text.BodyBase>
          </Box>
        )}
      </Box>
      {(primaryCta || secondaryCta) && (
        <Box as="div" name="Buttons" parent={name}>
          {primaryCta && (
            <PrimaryButton onClick={primaryCta.onClick} href={primaryCta.href} as={primaryCta.as}>
              {primaryCta.text}
            </PrimaryButton>
          )}
          {secondaryCta && (
            <TertiaryButton onClick={secondaryCta.onClick} href={secondaryCta.href} as={secondaryCta.as}>
              {secondaryCta.text}
            </TertiaryButton>
          )}
        </Box>
      )}
    </Box>
  </Box>
);

export default EmptyState;
